import React, { MouseEvent, ReactNode } from 'react';
import { BadgesGroup, Element, PackageAttributes, PriceContainer } from './PackageSummary.styles';
import { Text, Title } from '@/components/typography';
import Badge from '@/components/badge/Badge';
import { usePacoteDetailContext } from '@/features/pacote/PacoteDetail/context';
import TravelDetailList from '@/features/pacote/components/TravelDetailList/TravelDetailList';
import { TravelTypeIcon } from '@/features/pacote/PacotesList/components';

export interface PackageSummaryProps {
  className?: string;
  children?: ReactNode;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void | undefined;
}

const PackageSummary = ({ children, ...props }: PackageSummaryProps) => {
  const { data } = usePacoteDetailContext();
  const { pacote } = data;
  return (
    <Element>
      <Title as="h3" size="lg" color="neutral_500" align="center" weight="light">
        Resumo do Pacote
      </Title>
      <PriceContainer>
        {(pacote.travel_amount && (
          <Text as="span" weight="bold">
            Preço a partir de
          </Text>
        )) || (
          <Text as="span" weight="bold">
            Preço
          </Text>
        )}

        <Text as="span" size="xl" weight="bold">
          {(!pacote.travel_amount && (
            <Text as="small" size="md">
              Sob Consulta
            </Text>
          )) || (
            <>
              <Text as="small" size="md">
                {pacote.travel_currency}
              </Text>{' '}
              {pacote.travel_amount}
              {(pacote.travel_currency !== 'BRL' && <sup>*</sup>) || null}
            </>
          )}
        </Text>
        {(pacote.travel_amount && (
          <Text size="xs" as="small" textCase="uppercase">
            {pacote.travel_amount_info}
          </Text>
        )) ||
          null}
      </PriceContainer>
      <BadgesGroup>
        <Badge size="sm" color="primary_500">
          <TravelTypeIcon id={pacote.travel_type.slug} width={16} color="white" />
          {pacote.travel_type.title}
        </Badge>
        {(pacote.ribbon === 'EXCLUSIVO' && (
          <Badge size="sm" color="success_500">
            <TravelTypeIcon id={pacote.travel_type.slug} width={16} color="white" />
            Grupo Exclusivo
          </Badge>
        )) ||
          null}
      </BadgesGroup>
      <PackageAttributes>
        <TravelDetailList
          travel_type={pacote.travel_type}
          travel_city={pacote.travel_city}
          travel_duration={pacote.travel_duration}
          travel_depart={pacote.travel_depart}
          travel_flight={pacote.travel_flight}
          travel_meal={pacote.travel_meal}
          expired_at={pacote.expired_at}
          reference={pacote.reference}
        />
      </PackageAttributes>
      <div>
        <Text weight="light" size="xs" color="neutral_600">
          * Valor indicado em moeda estrangeira, convertido em reais de acordo com a cotação do dia do pagamento.
        </Text>
      </div>
    </Element>
  );
};

export default PackageSummary;
